'use client'

import { memo } from 'react'
import { NinkVoiceRibbon } from '@/app/nink/_components/nink-voice-ribbon'
import { NinxlScrollReveal } from './ninxl-scroll-reveal'
import { NinxlSectionHeader } from './ninxl-graphics'
import { NinxlInkflowShowcase } from './ninxl-inkflow-showcase'

/** baby: Minimal mode labels: no boxes, just hotkeys in one line */
const INKFLOW_MODES = [
  { title: 'Dictate', hotkey: '⇧ Shift' },
  { title: 'Instruct', hotkey: 'Caps Lock' },
  { title: 'Transform', hotkey: 'Chain' },
] as const

type NinxlInkflowSectionProps = {
  /** baby: Voice cleanup ribbon: on for /ninxl; /nink has its own in flow-compare */
  showVoiceRibbon?: boolean
  /** baby: Dictate HUD showcase card: off on craft v2 */
  showShowcase?: boolean
}

export const NinxlInkflowSection = memo(function NinxlInkflowSection({
  showVoiceRibbon = true,
  showShowcase = true,
}: NinxlInkflowSectionProps) {
  return (
    <div className="ninxl-inkflow-section">
      <div className="mx-auto max-w-3xl px-6 text-center">
        <NinxlScrollReveal>
          <NinxlSectionHeader
            label="INKFLOW"
            title="Speak. It writes everywhere."
            description="System-wide dictation and voice commands: on-device Whisper, liquid-glass HUD, paste at your cursor in any app."
            className="mb-0"
          />
        </NinxlScrollReveal>

        <NinxlScrollReveal delay={0.06}>
          <div className="ninxl-inkflow-modes" aria-label="InkFlow modes">
            {INKFLOW_MODES.map((mode, index) => (
              <span key={mode.title} className="ninxl-inkflow-modes-item">
                {index > 0 ? <span className="ninxl-inkflow-modes-sep" aria-hidden>·</span> : null}
                <span className="ninxl-inkflow-modes-title">{mode.title}</span>
                <span className="ninxl-inkflow-modes-hotkey">{mode.hotkey}</span>
              </span>
            ))}
          </div>
        </NinxlScrollReveal>
      </div>

      {showVoiceRibbon ? (
        <NinxlScrollReveal delay={0.08} variant="rise" className="mx-auto mt-10 max-w-6xl px-4 md:px-6">
          <NinkVoiceRibbon />
        </NinxlScrollReveal>
      ) : null}

      {showShowcase ? <NinxlInkflowShowcase /> : null}
    </div>
  )
})
